/**
 * ResponsavelUsuario
 * @author Thacryba
 */
import {$, HttpBody, ID, Resource, success} from 'simpli-web-sdk'
import {
  ResponseHidden,
  ResponseSerialize,
  ValidationEmail,
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import ResponsavelUsuarioSchema from '@/schema/ResponsavelUsuario.schema'
import {Exclude} from 'class-transformer'
import Responsavel from '@/model/resource/Responsavel'
import TipoResponsavelUsuario from '@/model/resource/TipoResponsavelUsuario'
import {sha256} from 'js-sha256'
import {cloneDeep} from 'lodash'
import * as Helper from '@/helpers'

export default class ResponsavelUsuario extends Resource {
  static async persistLote(listToPersist: ResponsavelUsuario[], spinner = 'persistLoteResponsavelUsuario') {
    const list = cloneDeep(listToPersist)
    list.forEach( (item) => {
      if (!item.$id && !item.senha) {
        Helper.abort('view.persist.respUserPersistView.passwordError')
      }
      item.senha = item.senha ? sha256(item.senha) : null
      item.ehSenhaTemporaria = !!item.senha
    })

    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-responsavel-usuario`, list)
    }

    return await $.await.run(fetch, spinner)
  }

  @Exclude()
  readonly $name: string = 'ResponsavelUsuario'

  @Exclude()
  readonly $endpoint: string = '/user/responsavel-usuario{/id}'

  get $schema() {
    return ResponsavelUsuarioSchema(this)
  }

  get $id() {
    return this.idResponsavelUsuarioPk
  }
  set $id(val: ID) {
    this.idResponsavelUsuarioPk = val
  }

  get $tag() {
    return this.nome || ''
  }
  set $tag(val: string) {
    this.nome = val
  }

  get idTipoResponsavelUsuarioFk() {
    if (!this.tipoRespUsuario) return 0
    return this.tipoRespUsuario.idTipoResponsavelUsuarioPk
  }
  set idTipoResponsavelUsuarioFk(val: number) {
    if (!this.tipoRespUsuario) this.tipoRespUsuario = new TipoResponsavelUsuario()
    this.tipoRespUsuario.idTipoResponsavelUsuarioPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.idResponsavelPk = val
  }

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  @ResponseSerialize(TipoResponsavelUsuario)
  tipoRespUsuario: TipoResponsavelUsuario | null = null

  idResponsavelUsuarioPk: ID = 0

  @Exclude()
  codigoAcesso: string | null = null

  @ValidationMaxLength(255)
  nome: string | null = null

  @ValidationMaxLength(100)
  @ValidationEmail()
  email: string | null = null

  @Exclude()
  dataGeracaoCodigoAcesso: string | null = null

  @Exclude()
  @ValidationRequired()
  ehSenhaTemporaria: boolean = false

  @Exclude()
  @ValidationRequired()
  permitirCadastrarUsuario: boolean = false

  @Exclude()
  @ValidationRequired()
  ativo: boolean = false

  @Exclude()
  @ResponseHidden()
  senha: string | null = null

  async persistResponsavelUsuario(spinner = 'persistResponsavelUsuario') {
    const request = this.clone()
    request.senha = this.senha ? sha256(this.senha) : null
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/responsavel-usuario`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getResponsavelUsuario(id: number | string, spinner = 'getResponsavelUsuario') {
    const fetch = async () => await this.GET(`/user/responsavel-usuario/${id}`)
    return await $.await.run(fetch, spinner)
  }

  get filialName() {
    return this.responsavel && `${this.responsavel.nomeFantasia} - ${Helper.cnpj(this.responsavel.cnpj)}`
  }

}
